import React from 'react'
import Tr from 'translations/Translations';
import {makeStyles} from '@material-ui/styles';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown'
import clsx from 'clsx';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

const useStyles = makeStyles({
	rotate: {
		transform: 'rotate(180deg)'
	},
})

function WorkableIconExpandButton({
	expanded,
	tooltip,
	...props
}) {
	const classes = useStyles();
	let _tooltip = tooltip;
	if (!_tooltip && !props.disabled) {
		_tooltip =  expanded ? Tr('collapse') : Tr('expand');
	}

	return <WorkableIconButton
		tooltip={_tooltip}
		Icon={ArrowIcon}
		className={clsx( props.className, {
			[classes.rotate]: expanded
		})}
		{...props}
	/>

}

WorkableIconExpandButton.propTypes = {
	expanded: PropTypes.bool,
	working: PropTypes.bool,
	disabled: PropTypes.bool,
	tooltip: PropTypes.string,
	hideTooltip: PropTypes.bool,
	color: PropTypes.string,
	onClick: PropTypes.func
}

export default WorkableIconExpandButton;